import React, { useEffect, useState } from "react";
import { Spin, Typography, Badge, Avatar } from "antd";
import Storage from "../../Data/Domain/Storage";
import { getUserRepository } from "../Infrastructure/Users.repository";
import { getAdminRepository } from "../../Administrator/Infrastructure/Administrators.repository";
import "./Users.css";
import { role as getRoleFromAPI } from "../../Login/Application/Auth.logic";
import USER from "../Domain/User";
import { useDispatch } from "react-redux";
import { setLocalRoles } from "../Infrastructure/Users.reducer";
import User from "../Domain/User";
import profile from "../../assets/profile/profile.png";

const { Text } = Typography;

const styles = {
  badge: {
    width: "11px",
    height: "11px",
    boxShadow: "0 0 0 5px #fff",
    backgroundColor: "#00DD9E",
  },
};

export default function UserReferenceField(props) {
  const {
    id,
    dashboard = false,
    showEditIcon = false,
    editComponent = null,
  } = props;
  const [user, setUser] = useState(null);
  const [roleObject, setRoleObject] = useState(null);
  const storedRol = new Storage("rol").getItem();
  if (!storedRol || typeof storedRol !== "string") {
    new Storage("rol").setItem("defaultRole");
  }
  const [selectedRol, setSelectedRol] = useState(() => {
    return storedRol ? storedRol : null;
  });
  const dispatch = useDispatch();

  function useBorderColor(imageSrc, border = 12) {
    const [color, setColor] = useState("#ffffff");

    useEffect(() => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = imageSrc;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const top = ctx.getImageData(0, 0, img.width, border).data;
        const bottom = ctx.getImageData(
          0,
          img.height - border,
          img.width,
          border
        ).data;
        const left = ctx.getImageData(0, 0, border, img.height).data;
        const right = ctx.getImageData(
          img.width - border,
          0,
          border,
          img.height
        ).data;
        const pixels = [...top, ...bottom, ...left, ...right];
        let r = 0,
          g = 0,
          b = 0,
          count = 0;
        for (let i = 0; i < pixels.length; i += 4) {
          r += pixels[i];
          g += pixels[i + 1];
          b += pixels[i + 2];
          count++;
        }
        r = Math.round(r / count);
        g = Math.round(g / count);
        b = Math.round(b / count);
        setColor(`rgb(${r}, ${g}, ${b})`);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imageSrc]);
    return color;
  }

  const finalImage = user?.profile_picture || profile;
  const isDefaultImage = finalImage === profile;
  const borderColor = useBorderColor(profile);

  async function getDataForUser() {
    const internal_id = id || new Storage("id").getItem();
    const role_string = new Storage("rol").getItem();

    if (role_string === User.PARTNER || (!dashboard && id)) {
      return await getUserRepository(internal_id);
    }
    if (
      role_string === User.ADMIN ||
      role_string === User.PROJECTS_VIEWER ||
      role_string === User.PROJECTS_SELLER ||
      role_string === User.CARBON_CREDITS ||
      role_string === User.CARBON_MANAGEMENT ||
      role_string === User.OWNER ||
      dashboard
    ) {
      return await getAdminRepository(internal_id);
    }
  }

  async function fetchRole() {
    const role_object = await getRoleFromAPI();
    const translatedUserRoles = role_object.role.map((role) => {
      const translatedRoles = USER.ROLES[role] || role;
      return { roleName: role, translatedRoles: translatedRoles };
    });
    setRoleObject({ ...role_object, role: translatedUserRoles });
    return role_object;
  }

  useEffect(() => {
    getDataForUser().then((user) => setUser(user));
    fetchRole().then((userRole) => {
      let selectRole = storedRol ? storedRol : userRole.role[0];
      setSelectedRol(selectRole);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const storage = new Storage("rol");
  const handleRoleClick = async (role) => {
    try {
      const role_object = await fetchRole();
      const rol = role_object.role.find((r) => r === role);
      setSelectedRol(rol);
      dispatch(setLocalRoles(rol));
      storage.setItem(rol);
      return rol;
    } catch (error) {}
  };

  return (
    <>
      {user ? (
        <div className={props.container}>
          <Badge dot={props.dot} offset={["-5%", "85%"]} style={styles.badge}>
            <div
              style={{
                width: props.size,
                height: props.size,
                padding: "4px",
                borderRadius: "50%",
                background: `
                conic-gradient(
                from 210deg,
              rgba(0,221,158,0) 0deg,
              rgba(0,221,158,0.4) 10deg,
              rgba(0,221,158,0.8) 20deg,
              rgba(0,221,158,1) 40deg,
              rgba(0,221,158,1) 250deg,
              rgba(0,221,158,0.8) 270deg,
              rgba(0,221,158,0.4) 285deg,
              rgba(0,221,158,0) 300deg,
              rgba(0,221,158,0) 360deg
               )
               `,
                WebkitMask:
                  "radial-gradient(farthest-side, #000 97%, transparent 100%)",
                mask:
                  "radial-gradient(farthest-side, #000 97%, transparent 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Avatar
                size={props.size - 8}
                src={finalImage}
                style={
                  isDefaultImage
                    ? {
                        backgroundColor: borderColor,
                        padding: 6,
                        borderRadius: "50%",
                        objectFit: "contain",
                      }
                    : {
                        borderRadius: "50%",
                        objectFit: "cover",
                        backgroundColor: "#fff",
                      }
                }
              />
            </div>
          </Badge>

          <div className={props.containerRight}>
            <div className={props.containerText}>
              <div className={"containerUserName"}>
                <Text className={props.stylesUsername}>{user.userName}</Text>
                {showEditIcon && editComponent && <span>{editComponent}</span>}
              </div>

              <Text className={props.occupationStyle}>{props.occupation}</Text>
            </div>

            <div className={"dropdown"}>
              {props.dropdown ? (
                <>{props.dropdown}</>
              ) : (
                <div className={"children"}>
                  {typeof props.children === "function"
                    ? props.children({
                        roleObject,
                        selectedRol,
                        handleRoleClick,
                      })
                    : props.children}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Spin />
      )}
    </>
  );
}
